// This is test environment used for testing on https://info-test.intowords.com.

import { NgxLoggerLevel } from 'ngx-logger';
import packageJson from '../../package.json';

export const environment = {
  version: packageJson.version,
  name: 'test',
  production: false,
  availableLanguages: [
    'da-DK',
    'nb-NO',
    'nn-NO',
    'sv-SE',
    'en-GB',
  ],
  logLevel: NgxLoggerLevel.OFF,
  location: 'https://status-test.intowords.com',
  UrlEndpoints: {
    cloudapp: 'https://cloudapp-test.intowords.com/',
    finger: 'https://10-finger-test.intowords.com',
    statusData: 'https://statusapi.test.vitecmv.com/api/ReleaseInfo',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
